import { useApi } from './api';
import { readJsonResponse, type ApiResult } from './apiResponse';
import type {
  SpecialistCaseMailCcConfigDto,
  SpecialistCaseMailCcConfigUpdateDto
} from '../types/specialistCaseMailCc';

export const useSpecialistCaseMailCcService = () => {
  const { apiFetch } = useApi();
  const base = '/admin/specialist-case-mail-cc';

  const getConfig = async (): Promise<ApiResult<SpecialistCaseMailCcConfigDto>> => {
    try {
      const res = await apiFetch(base);
      return readJsonResponse<SpecialistCaseMailCcConfigDto>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  const updateConfig = async (
    body: SpecialistCaseMailCcConfigUpdateDto
  ): Promise<ApiResult<SpecialistCaseMailCcConfigDto>> => {
    try {
      const res = await apiFetch(base, {
        method: 'PUT',
        body: JSON.stringify(body)
      });
      return readJsonResponse<SpecialistCaseMailCcConfigDto>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  return { getConfig, updateConfig };
};
